import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { IUser } from '../interfaces/users/user.interface';
import { mockUsers } from './users.mock';
import { environment } from '../../environments/environment';

export const mockUsersRes: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.USERS)) {
        const response: any = {
            status: 200,
            body: mockUsers,
        };
        return of(new HttpResponse(response));
    }

    if (request.method === 'GET' && request.url.includes(SubUrlsEnum.USER)) {
        const response: any = {
            status: 200,
            body: mockUsers.find((user: IUser) => user.id === +request.url.replace(environment.wasoApi + SubUrlsEnum.USER, '')),
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
